

export const TITLE_FONT_RATIO=22;
export const DESCRIPTION_FONT_RATIO=38;
export const LOGO_HEIGHT_RATIO=22;
